/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    Button,
    Dialog,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Typography,
    tableCellClasses,
    Paper,
    Grid,
    Stack,
    styled,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Chip,
    DialogActions,
    DialogTitle,
    DialogContent,
    Container,
    Card,
    CardActionArea,
    CardContent,
    Box,
  } from '@mui/material';
  import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
  import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
  import moment from 'moment';
  import { useNavigate } from 'react-router-dom';
  import React, { useContext, useEffect, useMemo, useState } from 'react';
  import { LocationOn } from '@mui/icons-material';
  import EditIcon from '@mui/icons-material/Edit';
  import CancelIcon from '@mui/icons-material/Cancel';
  import PersonPinIcon from '@mui/icons-material/PersonPin';
  import LocalShippingIcon from '@mui/icons-material/LocalShipping';
  import axios from '../../../utils/axios';
  import sea2 from '../../../media/Images/sea2.jpg';
  import seaicon from '../../../media/Images/seaicon.png';
  import airicon1 from '../../../media/Images/air-icon-1.png';
  import airicon2 from '../../../media/Images/air-icon-3.png';
  import air from '../../../media/Images/air3.jpg';
  import air2 from '../../../media/Images/2.jpg';
  import '../../stylemod.css';
  import UIContext from '../../../context/UIContext';
  import NoResultsFound from '../../../components/NoResultsFound';
  
  const StyledTableCell = styled(TableCell)({
    color: 'white',
    fontWeight: '600',
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#257180',
    },
    whiteSpace: 'nowrap',
  });

  const formatCrmDateOfBirth = (value) => {
    if (!value) return '-';
    const dateOfBirth = moment.utc(value);
    if (!dateOfBirth.isValid() || dateOfBirth.format('YYYY-MM-DD') === '1900-01-01') return '-';
    return dateOfBirth.format('DD-MM-YYYY');
  };
  
  // const shipMentTypesforIN = [
  //   { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  //   { label: 'Air Cargo - India', value: 'ACI' },
  // ];
  
  // const shipMentTypesforUK = [
  //   { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  //   { label: 'Air Cargo - India', value: 'ACI' },
  //   { label: 'Sea Cargo - Srilanka', value: 'SCSL' },
  // ];
  
  const shipMentTypesforIN = [
    { label: 'Air Cargo Srilanka', value: 'ACSL', image: air, icon: airicon2 },
    { label: 'Air Cargo India', value: 'ACI', image: air2, icon: airicon1 },
  ];
  
  const shipMentTypesforUK = [
    { label: 'Air Cargo Srilanka', value: 'ACSL', image: air, icon: airicon2 },
    { label: 'Air Cargo India', value: 'ACI', image: air2, icon: airicon1 },
    { label: 'Sea Cargo Srilanka', value: 'SCSL', image: sea2, icon: seaicon },
  ];
  
  const statusOptions = [
    { label: 'All', value: 'All' },
    { label: 'Pending', value: 'P' },
    { label: 'Approved', value: 'A' },
    { label: 'Cancel', value: 'C' },
  ];
  
  const typeOptions = [
    { label: 'Air-Cargo', value: 'courier' },
    { label: 'Sea-Cargo', value: 'cargo' },
  ];
  
  const filteredOptions = typeOptions.filter((option) =>
    sessionStorage.getItem('Origin') === 'IN' ? option.value === 'courier' : true
  );
  
  const SignUpCRM = () => {
    const navigate = useNavigate();
    const [getDataForView, setGetDataForView] = useState([]);
    const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [rowDeleteID, setRowDeleteID] = useState(null);
    const [openShipmentPopup, setOpenShipmentPopup] = useState(false);
    const [selectedShipment, setSelectedShipment] = useState('');
    const [error, setError] = useState('');
    const [filterInputs, setFilterInputs] = useState({
      fromDate: moment().startOf('month').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      status: 'All',
      type: sessionStorage.getItem('Origin') === 'UK' ? 'cargo' : 'courier',
    });
  
    const origin = sessionStorage.getItem('Origin') || 'IN'; // Default to IN if not set
    const shipmentTypes = origin === 'IN' ? shipMentTypesforIN : shipMentTypesforUK;
  
    const handleCardClick = (value) => {
      setSelectedShipment(value);
      handleProceed();
      setError('');
    };
  
    const handleConfirmDelete = () => {
      if (rowDeleteID !== null) {
        cancelOrder();
      }
      handleCloseConfirmDialog();
    };
  
    const handleOpenConfirmDialog = (boxIndex) => {
      setRowDeleteID(boxIndex);
      setOpenConfirmDialog(true);
    };
  
    const handleCloseConfirmDialog = () => {
      setOpenConfirmDialog(false);
      setRowDeleteID(null);
    };
  
    // const handleFilterInputs = (e) => {
    //   setGetDataForView([]);
    //   setFilterInputs({
    //     ...filterInputs,
    //     [e.target.name]: e.target.value,
    //   });
    // };
  
    async function getAllData() {
      // if (!validateFilters()) {
      //   return; // If validation fails, stop the request
      // }
  
      if (!validateDateInputs(filterInputs)) {
        return; // Stop the request if date validation fails
      }
  
      try {
        showLoading();
        const branchId = 0;
        const companyId = sessionStorage.getItem('CompanyId');
  
        const newData = {
            FromDate: moment(filterInputs.fromDate).format('YYYY-MM-DD'),
            ToDate: moment(filterInputs.toDate).format('YYYY-MM-DD'),
          };
      
        const  response = await axios.post(
            `SignUp/GetCRMdata`,newData
           
            // ${moment(filterInputs.fromDate).format('YYYYMMDD')}/${moment(
            //   filterInputs.toDate
            // ).format('YYYYMMDD')}/${filterInputs.status}/${companyId}/${branchId}/${sessionStorage.getItem('UserId')}`
          );
       
  
        setGetDataForView(response.data);
      } catch (e) {
        openSnackBar(e.response?.data?.message || 'Something went wrong! Try again.', 'error');
      }
      hideLoading();
    }
  
    useEffect(() => {
      getAllData();
      setTimeout(() => {
        if (sessionStorage.getItem('NewOrderPopupShown') === 'N') {
          setOpenShipmentPopup(true);
          sessionStorage.setItem('NewOrderPopupShown', 'Y');
        }
      }, 3000);
    }, []);
  
    // pagination
    const { totalRows, currentPage } = useMemo(() => {
      const totalRows = getDataForView.length;
      const totalPages = Math.ceil(totalRows / rowsPerPage);
      const currentPage = Math.max(0, Math.min(page, totalPages - 1));
      const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);
  
      return { totalRows, currentPage };
    }, [getDataForView, page, rowsPerPage]);
  
    const cancelOrder = async () => {
      try {
        let res;
        if (filterInputs.type === 'courier') {
          res = await axios.put(`/Transactions/Courier/CancelCourierOrder/${rowDeleteID}/${'Y'}`, {
            headers: {
              Country: origin,
            },
          });
        } else {
          res = await axios.put(`/Transactions/Cargo/CancelCargoOrder/${rowDeleteID}/${'Y'}`, {
            headers: {
              Country: origin,
            },
          });
        }
        getAllData();
        openSnackBar('Order has been cancelled successfully');
      } catch (err) {
        console.log(err.message);
      }
    };
  
    const handleNewBookingClick = () => {
      setOpenShipmentPopup(true);
    };
  
    const handleShipmentChange = (event) => {
      setSelectedShipment(event.target.value);
      setError('');
    };
  
    const handleProceed = (value) => {
      if (!value) {
        setError('Please select a shipment type.');
        return;
      }
      // Route based on selected shipment type
      if (value === 'SCSL') {
        navigate(`/dashboard/manage/cargo_order_creation/${value}`);
      } else {
        navigate(`/dashboard/manage/courier_order_creation/${value}`);
      }
      setOpenShipmentPopup(false);
    };
  
    const [formErrors, setFormErrors] = useState({
      fromDate: '',
      toDate: '',
    });
  
    const validateFilters = () => {
      const errors = {};
      // Validate fromDate: should not be empty
      if (!filterInputs.fromDate) {
        errors.fromDate = 'From date is required';
      } else if (!moment(filterInputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
        errors.fromDate = 'Invalid date format';
      }
  
      // Validate toDate: should not be empty and be a valid date
      if (!filterInputs.toDate) {
        errors.toDate = 'To date is required';
      } else if (!moment(filterInputs.toDate, 'YYYY-MM-DD', true).isValid()) {
        errors.toDate = 'Invalid date format';
      }
  
      setFormErrors(errors);
      return Object.keys(errors).length === 0; // Return true if no errors
    };
  
    const validateDateInputs = (inputs) => {
      const errors = {};
  
      // Validate fromDate
      if (!inputs.fromDate) {
        errors.fromDate = 'From date is required';
      } else if (!moment(inputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
        errors.fromDate = 'Invalid date format';
      }
  
      // Validate toDate
      if (!inputs.toDate) {
        errors.toDate = 'To date is required';
      } else if (!moment(inputs.toDate, 'YYYY-MM-DD', true).isValid()) {
        errors.toDate = 'Invalid date format';
      }
  
      setFormErrors(errors);
      return Object.keys(errors).length === 0;
    };
  
    const handleFilterInputs = (e) => {
      const { name, value } = e.target;
  
      setFilterInputs({
        ...filterInputs,
        [name]: value,
      });
  
      // Trigger validation for date fields only
      if (name === 'fromDate' || name === 'toDate') {
        validateDateInputs({ ...filterInputs, [name]: value });
      }
    };
  
    return (
      <>
        <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
          <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
            <Typography
              variant="h5"
              p={0.5}
              boxShadow={1}
              borderColor="#11235A"
              textAlign={'center'}
              borderRadius={12}
              pl={2}
              color="white"
              sx={{
                background: '#8ABFA3',
                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
              }}
            >
              <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              CRM
              </Typography>
            </Typography>
          </Grid>
  
          <Grid container spacing={2} p={1} my={0.5} rowSpacing={2} columnSpacing={1}>
           
  
            <Grid item md={2} xs={12}>
              {/* From Date */}
              <TextField
                fullWidth
                label="From Date"
                type="date"
                name="fromDate"
                value={filterInputs.fromDate}
                onChange={handleFilterInputs}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                size="small"
                error={!!formErrors.fromDate}
                helperText={formErrors.fromDate}
                inputProps={{ max: '9999-12-31' }}
              />
            </Grid>
            <Grid item md={2} xs={12}>
              {/* To Date */}
              <TextField
                fullWidth
                label="To Date"
                type="date"
                name="toDate"
                value={filterInputs.toDate}
                onChange={handleFilterInputs}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                size="small"
                error={!!formErrors.toDate}
                helperText={formErrors.toDate}
                inputProps={{ max: '9999-12-31' }}
              />
            </Grid>
  
            <Grid item md={1} xs={12}>
              {/* View Button */}
              <Button variant="contained" color="success" onClick={getAllData} fullWidth>
                View
              </Button>
            </Grid>
            {/* <Grid item md={2} xs={12}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                endIcon={<LocalShippingIcon style={{ color: 'white' }} />}
                sx={{
                  whiteSpace: 'nowrap',
                  boxShadow: '0',
                  position: 'relative',
                  zIndex: 1,
                  overflow: 'hidden',
                }}
                onClick={handleNewBookingClick}
                className="booking_button_newBooking"
              >
                New Booking
              </Button>
            </Grid> */}
          </Grid>
          {getDataForView.length > 0 ? (
            <>
              <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center">S.No</StyledTableCell>
                      {/* {filterInputs.type === 'courier' ? (
                        <StyledTableCell align="left">Courier Ref No</StyledTableCell>
                      ) : (
                        <StyledTableCell align="left">Cargo Ref No</StyledTableCell>
                      )}
  
                      {filterInputs.type === 'courier' ? (
                        <StyledTableCell align="left">Courier Date</StyledTableCell>
                      ) : (
                        <StyledTableCell align="left">&nbsp;Cargo Date&nbsp;</StyledTableCell>
                      )} */}
                      <StyledTableCell align="center">First Name</StyledTableCell>
                      <StyledTableCell align="center">Last Name</StyledTableCell>
                      <StyledTableCell align="center" sx={{ minWidth: 120 }}>
                        DOB
                      </StyledTableCell>
                      <StyledTableCell align="left">Country</StyledTableCell>
                      <StyledTableCell align="center">State</StyledTableCell>
                      <StyledTableCell align="center">City</StyledTableCell>
                      <StyledTableCell align="center">E-Mail</StyledTableCell>
                      <StyledTableCell align="center">Mobile No</StyledTableCell>
                      <StyledTableCell align="center">Alternative Mobile No</StyledTableCell>
  
                      {/* <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2 }}>
                        Actions
                      </StyledTableCell> */}
                    </TableRow>
                  </TableHead>
  
                  <TableBody>
                    {(rowsPerPage > 0
                      ? getDataForView.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : getDataForView
                    ).map((data, i) => (
                      <>
                        <TableRow key={data.CUSTOMERID} hover>
                          {/* <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
  
                          {filterInputs.type === 'courier' ? (
                            <TableCell align="center">{data.COURIER_NO}</TableCell>
                          ) : (
                            <TableCell align="center">{data.cargo_No}</TableCell>
                          )}
                          {filterInputs.type === 'courier' ? (
                            <TableCell align="center">
                              {moment(data.courierDate, 'DD/MM/YYYY')?.format('DD-MM-YYYY') || '-'}
                            </TableCell>
                          ) : (
                            <TableCell align="center">
                              {moment(data.cargoDate, 'DD/MM/YYYY')?.format('DD-MM-YYYY') || '-'}
                            </TableCell>
                          )}
                          <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                            {data.CUSTOMERNAME || '-'}
                          </TableCell>
  
                          <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                            <Stack spacing={1} py={1}>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <PersonPinIcon fontSize="x-small" color="primary" />
                                <Typography variant="subtitle2" color="#243642" pr={1}>
                                  {data.SENDER_NAME}
                                </Typography>{' '}
                              </Stack>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <LocationOn fontSize="x-small" color="error" />
                                <Typography variant="body2">
                                  {data.SENDER_CITY}, {data.SENDER_STATE}, <br />
                                  {data.SENDER_COUNTRY}, {data.SENDER_PINCODE}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                          <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                            <Stack spacing={1} py={1}>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <PersonPinIcon fontSize="x-small" color="primary" />
                                <Typography variant="subtitle2" color="#243642" pr={1}>
                                  {data.RECEIVER_NAME}
                                </Typography>{' '}
                              </Stack>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <LocationOn fontSize="x-small" color="error" />
                                <Typography variant="body2">
                                  {data.RECEIVER_CITY}, {data.RECEIVER_STATE}, <br />
                                  {data.RECEIVER_COUNTRY}, {data.RECEIVER_PINCODE}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                          <TableCell align="center">
                            {data.OrderRaised === 'Y' ? (
                              <Chip label="Booking Confirmed" size="small" color="info" />
                            ) : data.STATUS === 'C' ? (
                              <Chip label="Cancelled" size="small" color="error" />
                            ) : data.SE_OrderCancelReq === 'R' ? (
                              <Chip label="Cancel Request" size="small" color="error" />
                            ) : data.STATUS === 'A' ? (
                              <Chip label="Approved" size="small" color="success" />
                            ) : (
                              <Chip label="Pending" size="small" color="warning" />
                            )}
                          </TableCell>
                          <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                            {data.NO_OF_BOXES || '-'}
                          </TableCell> */}
{/*   
                          <TableCell
                            align="center"
                            sx={{ position: 'sticky', right: 0, bgcolor: '#F9FAFB', zIndex: 1, whiteSpace: 'nowrap' }}
                          >
                            <Stack
                              direction="column"
                              spacing={1}
                              justifyContent="center"
                              alignItems="center"
                              sx={{ width: '100%' }}
                            >
                              <Chip
                                icon={
                                  data.STATUS === 'A' ? (
                                    <RemoveRedEyeIcon />
                                  ) : data.STATUS === 'C' || data.SE_OrderCancelReq === 'R' ? (
                                    <RemoveRedEyeIcon />
                                  ) : (
                                    <EditIcon />
                                  )
                                }
                                size="small"
                                label={
                                  data.STATUS === 'A'
                                    ? 'preview'
                                    : data.STATUS === 'C' || data.SE_OrderCancelReq === 'R'
                                    ? 'preview'
                                    : 'Edit'
                                }
                                color={data.STATUS === 'C' || data.SE_OrderCancelReq === 'R' ? 'error' : 'primary'}
                                variant={
                                  data.STATUS === 'A'
                                    ? 'outlined'
                                    : data.STATUS === 'C' || data.SE_OrderCancelReq === 'R'
                                    ? 'outlined'
                                    : 'outlined'
                                }
                                sx={{ width: '100%' }}
                                onClick={() => {
                                  if (filterInputs.type === 'courier') {
                                    if (data.STATUS === 'C' || data.SE_OrderCancelReq === 'R') {
                                      navigate(`/dashboard/manage/courier_order_creation/Edit/${data.courier_Id}/A`);
                                    } else {
                                      navigate(
                                        `/dashboard/manage/courier_order_creation/Edit/${data.courier_Id}/${data.STATUS}`
                                      );
                                    }
                                  } else {
                                    if (data.STATUS === 'C' || data.SE_OrderCancelReq === 'R') {
                                      navigate(`/dashboard/manage/cargo_order_creation/Edit/${data.cargo_Id}/A`);
                                    } else {
                                      navigate(
                                        `/dashboard/manage/cargo_order_creation/Edit/${data.cargo_Id}/${data.STATUS}`
                                      );
                                    }
                                  }
                                }}
                              />
                              {data.SE_OrderCancelReq === 'N' && data.STATUS === 'P' && (
                                <Chip
                                  icon={<CancelIcon />}
                                  label="Cancel"
                                  color="error"
                                  size="small"
                                  sx={{ width: '100%' }}
                                  onClick={() => {
                                    if (filterInputs.type === 'courier') {
                                      if (data.STATUS === 'C') {
                                        alert('Order Cancelled Cannot Edit or Delete !', 'waring');
                                      } else if (data.STATUS === 'P') {
                                        handleOpenConfirmDialog(data.courier_Id);
                                      } else {
                                        alert('Order Approved Cannot Edit or Delete !', 'waring');
                                      }
                                    } else {
                                      if (data.STATUS === 'C') {
                                        alert('Order Cancelled Cannot Edit or Delete !', 'waring');
                                      } else if (data.STATUS === 'P') {
                                        handleOpenConfirmDialog(data.cargo_Id);
                                      } else {
                                        alert('Order Approved Cannot Edit or Delete !', 'waring');
                                      }
                                    }
                                  }}
                                />
                              )}
                            </Stack>
                          </TableCell> */}
                          <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                          <TableCell align="center">
                            {data.firstName}
                            </TableCell>
                            <TableCell align="center">
                            {data.lastName}
                            </TableCell>
                            <TableCell align="center">
                              {formatCrmDateOfBirth(data.dateOfBirth)}
                            </TableCell>
                            <TableCell align="center">
                            {data.country}
                            </TableCell>
                            <TableCell align="center">
                            {data.state}
                            </TableCell>
                            <TableCell align="center">
                            {data.city}
                            </TableCell>
                            <TableCell align="center">{data.email}</TableCell>
                            <TableCell align="center">{data.contactNo}</TableCell>
                            <TableCell align="center">{data.alternativeNo}</TableCell>
                        </TableRow>
                      </>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
  
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalRows}
                rowsPerPage={rowsPerPage}
                page={currentPage}
                onPageChange={(event, newPage) => setPage(newPage)}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(0);
                }}
                mt={2}
              />
            </>
          ) : (
            <NoResultsFound />
          )}
  
          {/* Confirmation Dialog for Deletion */}
          <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
            <DialogTitle>Confirm Cancel</DialogTitle>
            <DialogContent>
              <Typography>Are you sure you want to Cancel this Order?</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseConfirmDialog} color="warning">
                Close
              </Button>
              <Button onClick={handleConfirmDelete} color="error">
                Yes
              </Button>
            </DialogActions>
          </Dialog>
  
          {/* MUI Popup */}
          <Dialog
            open={openShipmentPopup}
            onClose={() => setOpenShipmentPopup(false)}
            maxWidth="sm"
            // fullWidth
            PaperProps={{
              sx: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              },
            }}
          >
            <DialogContent>
              <Stack>
                <Typography variant="h6" color="white" align="center" mb={3}>
                  Choose and Start Your Booking Now
                </Typography>
                <Grid container spacing={2}>
                  {shipmentTypes.map((type) => (
                    <Grid item xs={12} sm={6} md={origin === 'IN' ? 6 : 4} key={type.value}>
                      <Card
                        onClick={() => handleProceed(type.value)}
                        sx={{
                          position: 'relative',
                          overflow: 'hidden',
                          boxShadow:
                            selectedShipment === type.value
                              ? 'rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset'
                              : '0 4px 8px rgba(0, 0, 0, 0.1)',
                          borderRadius: 2,
                          scale: selectedShipment === type.value ? 1.1 : 1,
                          border: selectedShipment === type.value ? '2px solid #6A9C89' : '1px solid #ddd',
                        }}
                        className="card_hover_effect"
                      >
                        {/* Background Image */}
                        <Box
                          component="img"
                          src={type.image}
                          alt={type.label}
                          sx={{
                            width: '100%',
                            height: 200,
                            objectFit: 'cover',
                          }}
                        />
                        {/* Circular Icon Overlay */}
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 168,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 70,
                            height: 70,
                            borderRadius: '50%',
                            backgroundColor: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                          }}
                        >
                          <Box
                            component="img"
                            src={type.icon}
                            alt={`${type.label} Icon`}
                            sx={{ width: 40, height: 40, objectFit: 'cover' }}
                          />
                        </Box>
                        {/* Content */}
                        <CardContent sx={{ textAlign: 'center', mt: 3 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#0D7C66' }}>
                            {type.label}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                {/* <Stack justifyContent="center" alignItems={'center'} direction={'row'} spacing={2} my={2}>
                  <Button onClick={() => setOpenShipmentPopup(false)} color="warning" variant="contained" size="small">
                    Close
                  </Button>
                </Stack> */}
                {error && (
                  <Typography variant="caption" color="error" margin="4px 0 0">
                    {error}
                  </Typography>
                )}
              </Stack>
            </DialogContent>
          </Dialog>
        </Container>
      </>
    );
  };
  
  export default SignUpCRM;
  